import { ApiService } from '~/shared/api'
import { QueryParams } from '~/shared/interfaces'
import { FiltersWithFavoriteModel } from '~/model/Filters'
import { ResponseListModel } from '~/model/Response'

export default class AccountReportsService extends ApiService {
  async getReportsFilters(slug: string, params?: QueryParams): Promise<FiltersWithFavoriteModel> {
    const res: any = await this.requestService.request({
      url: `/api/v1/yavagro/users-management/reports/${slug}/filters`,
      params
    })

    return new FiltersWithFavoriteModel(res.data.data)
  }

  getReportsTable(slug: string, params?: QueryParams): Promise<ResponseListModel> {
    return this.requestService
      .request({
        url: `/api/v1/yavagro/users-management/reports/${slug}`,
        params
      })
      .then(res => new ResponseListModel(res.data))
      .catch(err => {
        console.warn(err) // eslint-disable-line no-console
        return new ResponseListModel(null)
      })
  }
}
